import React from "react";
import { IWaterCooledChillerReading } from "../../../vm";
import { ToastContext } from "../../common/ToastProvider";
import { ConfirmDialogContext } from "../../common/ConfirmDialogProvider";
import {
  IStackTokens,
  PanelType,
  Stack,
  Toggle,
  DefaultButton,
  PrimaryButton,
  DatePicker,
  DayOfWeek,
  DatePickerBase,
} from "office-ui-fabric-react";
import { getAlertDetails } from "../../../services/ThresholdService";
import CustomDrawer from "../../common/CustomDrawer";
import { Formik } from "formik";
import { updateWccReading } from "../../../services/infrastructure/AccService";
import { CustomTextField } from "../../common/Library";
import * as yup from "yup";
import { CategoryHeader } from "../Misc";
import Datetime from "react-datetime";

const evaporatorDoubleSchema = yup.object().shape({
  chwInletPressure: yup.number().required("required"),
  chwOutletPressure: yup.number().required("required"),
  activeChwSetPoint: yup.number().required("required"),
  chwInletTemperature: yup.number().required("required"),
  chwOutletTemperature: yup.number().required("required"),
  refrigerantSaturatedTempCkt01: yup.number().required("required"),
  refrigerantSaturatedTempCkt02: yup.number().required("required"),
  refrigerantPressureCkt01: yup.number().required("required"),
  refrigerantPressureCkt02: yup.number().required("required"),
  approachCkt01: yup.number().required("required"),
  approachCkt02: yup.number().required("required"),
});

const condenserDoubleSchema = yup.object().shape({
  inletPressure: yup.number().required("required"),
  outletPressure: yup.number().required("required"),
  inletTemperature: yup.number().required("required"),
  outletTemperature: yup.number().required("required"),
  refrigerantSaturatedTempCkt01: yup.number().required("required"),
  refrigerantSaturatedTempCkt02: yup.number().required("required"),
  refrigerantPressureCkt01: yup.number().required("required"),
  refrigerantPressureCkt02: yup.number().required("required"),
  approachCkt01: yup.number().required("required"),
  approachCkt02: yup.number().required("required"),
});

const compressorDoubleSchema = yup.object().shape({
  runningTimeCkt01: yup.number().required("required"),
  runningTimeCkt02: yup.number().required("required"),
  oilTankPressureCkt01: yup.number().required("required"),
  oilTankPressureCkt02: yup.number().required("required"),
  oilDischargePressureCkt01: yup.number().required("required"),
  oilDischargePressureCkt02: yup.number().required("required"),
  oilDiffOilPressureCkt01: yup.number().required("required"),
  oilDiffOilPressureCkt02: yup.number().required("required"),
  oilTankTempCkt01: yup.number().required("required"),
  oilTankTempCkt02: yup.number().required("required"),
  igvPositionCkt01: yup.number().required("required"),
  igvPositionCkt02: yup.number().required("required"),
  igvStepsCkt01: yup.number().required("required"),
  igvStepsCkt02: yup.number().required("required"),
});

const motorDoubleSchema = yup.object().shape({
  rlaL1Ckt01: yup.number().required("required"),
  rlaL1Ckt02: yup.number().required("required"),
  rlaL2Ckt01: yup.number().required("required"),
  rlaL2Ckt02: yup.number().required("required"),
  rlaL3Ckt01: yup.number().required("required"),
  rlaL3Ckt02: yup.number().required("required"),
  compLineCurrentL1Ckt01: yup.number().required("required"),
  compLineCurrentL1Ckt02: yup.number().required("required"),
  compLineCurrentL2Ckt01: yup.number().required("required"),
  compLineCurrentL2Ckt02: yup.number().required("required"),
  compLineCurrentL3Ckt01: yup.number().required("required"),
  compLineCurrentL3Ckt02: yup.number().required("required"),
  compLineVoltABCkt01: yup.number().required("required"),
  compLineVoltABCkt02: yup.number().required("required"),
  compLineVoltBCCkt01: yup.number().required("required"),
  compLineVoltBCCkt02: yup.number().required("required"),
  compLineVoltACCkt01: yup.number().required("required"),
  compLineVoltACCkt02: yup.number().required("required"),
  compressorKilowattsCkt01: yup.number().required("required"),
  compressorKilowattsCkt02: yup.number().required("required"),
  compressorPowerFactorCkt01: yup.number().required("required"),
  compressorPowerFactorCkt02: yup.number().required("required"),
  compWindingTempW1Ckt01: yup.number().required("required"),
  compWindingTempW1Ckt02: yup.number().required("required"),
  compWindingTempW2Ckt01: yup.number().required("required"),
  compWindingTempW2Ckt02: yup.number().required("required"),
  compWindingTempW3Ckt01: yup.number().required("required"),
  compWindingTempW3Ckt02: yup.number().required("required"),
});

const purgeDoubleSchema = yup.object().shape({
  timeUntilNextPurgeCkt01: yup.number().required("required"),
  timeUntilNextPurgeCkt02: yup.number().required("required"),
  dailyPumpOutCkt01: yup.number().required("required"),
  dailyPumpOutCkt02: yup.number().required("required"),
  avgPumpOutCkt01: yup.number().required("required"),
  avgPumpOutCkt02: yup.number().required("required"),
  dailyPumpOutLimitCkt01: yup.number().required("required"),
  dailyPumpOutLimitCkt02: yup.number().required("required"),
  chillerOn7DaysCkt01: yup.number().required("required"),
  chillerOn7DaysCkt02: yup.number().required("required"),
  pumpOutChillerOn7DaysCkt01: yup.number().required("required"),
  pumpOutChillerOn7DaysCkt02: yup.number().required("required"),
  pumpOutChillerOff7DaysCkt01: yup.number().required("required"),
  pumpOutChillerOff7DaysCkt02: yup.number().required("required"),
  pumpOutLifeCkt01: yup.number().required("required"),
  pumpOutLifeCkt02: yup.number().required("required"),
  purgeRefCompSuctionTempCkt01: yup.number().required("required"),
  purgeRefCompSuctionTempCkt02: yup.number().required("required"),
  purgeLiquidTempCkt01: yup.number().required("required"),
  purgeLiquidTempCkt02: yup.number().required("required"),
  carbonTankTempCkt01: yup.number().required("required"),
  carbonTankTempCkt02: yup.number().required("required"),
  oilTankLevelCkt01: yup.number().required("required"),
  oilTankLevelCkt02: yup.number().required("required"),
});

const wccReadingDoubleSchema = yup.object().shape({
  evaporator: evaporatorDoubleSchema,
  condenser: condenserDoubleSchema,
  compressor: compressorDoubleSchema,
  motor: motorDoubleSchema,
  purge: purgeDoubleSchema,
  recordedBy: yup.string().required("required"),
  remarks: yup.string().optional(),
});

const evaporatorSingleSchema = yup.object().shape({
  chwInletPressure: yup.number().required("required"),
  chwOutletPressure: yup.number().required("required"),
  activeChwSetPoint: yup.number().required("required"),
  chwInletTemperature: yup.number().required("required"),
  chwOutletTemperature: yup.number().required("required"),
  refrigerantSaturatedTempCkt01: yup.number().required("required"),
  refrigerantPressureCkt01: yup.number().required("required"),
  approachCkt01: yup.number().required("required"),
});

const condenserSingleSchema = yup.object().shape({
  inletPressure: yup.number().required("required"),
  outletPressure: yup.number().required("required"),
  inletTemperature: yup.number().required("required"),
  outletTemperature: yup.number().required("required"),
  refrigerantSaturatedTempCkt01: yup.number().required("required"),
  refrigerantPressureCkt01: yup.number().required("required"),
  approachCkt01: yup.number().required("required"),
});

const compressorSingleSchema = yup.object().shape({
  runningTimeCkt01: yup.number().required("required"),
  oilTankPressureCkt01: yup.number().required("required"),
  oilDischargePressureCkt01: yup.number().required("required"),
  oilDiffOilPressureCkt01: yup.number().required("required"),
  oilTankTempCkt01: yup.number().required("required"),
  igvPositionCkt01: yup.number().required("required"),
  igvStepsCkt01: yup.number().required("required"),
});

const motorSingleSchema = yup.object().shape({
  rlaL1Ckt01: yup.number().required("required"),
  rlaL2Ckt01: yup.number().required("required"),
  rlaL3Ckt01: yup.number().required("required"),
  compLineCurrentL1Ckt01: yup.number().required("required"),
  compLineCurrentL2Ckt01: yup.number().required("required"),
  compLineCurrentL3Ckt01: yup.number().required("required"),
  compLineVoltABCkt01: yup.number().required("required"),
  compLineVoltBCCkt01: yup.number().required("required"),
  compLineVoltACCkt01: yup.number().required("required"),
  compressorKilowattsCkt01: yup.number().required("required"),
  compressorPowerFactorCkt01: yup.number().required("required"),
  compWindingTempW1Ckt01: yup.number().required("required"),
  compWindingTempW2Ckt01: yup.number().required("required"),
  compWindingTempW3Ckt01: yup.number().required("required"),
});

const purgeSingleSchema = yup.object().shape({
  timeUntilNextPurgeCkt01: yup.number().required("required"),
  dailyPumpOutLimitCkt01: yup.number().required("required"),
  chillerOn7DaysCkt01: yup.number().required("required"),
  pumpOutChillerOn7DaysCkt01: yup.number().required("required"),
  pumpOutChillerOff7DaysCkt01: yup.number().required("required"),
  pumpOutLifeCkt01: yup.number().required("required"),
  purgeRefCompSuctionTempCkt01: yup.number().required("required"),
  purgeLiquidTempCkt01: yup.number().required("required"),
  carbonTankTempCkt01: yup.number().required("required"),
  oilTankLevelCkt01: yup.number().required("required"),
});

const wccReadingSingleSchema = yup.object().shape({
  evaporator: evaporatorSingleSchema,
  condenser: condenserSingleSchema,
  compressor: compressorSingleSchema,
  motor: motorSingleSchema,
  purge: purgeSingleSchema,
  recordedBy: yup.string().required("required"),
  remarks: yup.string().optional(),
});

export interface ManageWccDialogProps {
  data?: IWaterCooledChillerReading;
  handleLoading: any;
  handleDialogClose: any;
  threshold: any;
}

const ManageWccDialog: React.FC<ManageWccDialogProps> = ({
  data,
  handleDialogClose,
  handleLoading,
  threshold,
}) => {
  //state
  const [state, setState] = React.useState({
    wccReading: {
      ...data,
    },
    isLoading: false,
  } as {
    wccReading: IWaterCooledChillerReading;
    isLoading: boolean;
  });

  //hooks
  const { showToast } = React.useContext(ToastContext);
  const { showConfirmDialog } = React.useContext(ConfirmDialogContext);

  const wrapStackTokens: IStackTokens = { childrenGap: 16 };

  const closeUpdateDialoge = (data?: IWaterCooledChillerReading) => {
    handleDialogClose(data);
  };

  const onBlurFunc = (value: any, path: string) => {
    console.log("onBlurFunc");
    const { showAlert, msg } = getAlertDetails(path, threshold, value);
    console.log("[showAlert]", showAlert, msg);
    if (showAlert === true) {
      showConfirmDialog("Alert", msg as string, () => { }, "Ok", true);
    }
  };

  return (
    <React.Fragment>
      <CustomDrawer
        drawerType={PanelType.large}
        title={"Update Water Cooled Chiller Reading"}
        onClose={() => closeUpdateDialoge()}
      >
        <Stack>
          <Formik
            initialValues={state.wccReading}
            // validationSchema={
            //   state.wccReading.circuitType === "double"
            //     ? wccReadingDoubleSchema
            //     : wccReadingSingleSchema
            // }
            onSubmit={async (
              values: IWaterCooledChillerReading,
              { setSubmitting }
            ) => {
              let obj = { ...values };
              let result;
              handleLoading();
              result = await updateWccReading(obj);
              handleLoading();
              if (result?.success) {
                closeUpdateDialoge(result.data);
                showToast(
                  `Water Cooled Chiller Reading updated successfully`,
                  "success"
                );
              } else {
                showToast(
                  `Error while updating Water Cooled Chiller reading`,
                  "error"
                );
              }
              setSubmitting(false);
            }}
          >
            {({ handleSubmit, values, setFieldValue }) => (
              <form onSubmit={handleSubmit}>
                <div className="ms-Grid">
                  <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-xs12 ms-sm12 ms-md12 custom-toggle">
                      <Toggle
                        checked={values.isSystemOn}
                        onText="On"
                        offText="Off"
                        onChange={(e, v) => setFieldValue("isSystemOn", v)}
                        label="System"
                      />
                    </div>
                    <div className="ms-Grid-col ms-xs12 ms-sm12">
                      <CategoryHeader title="EVAPORATOR" />
                    </div>
                    <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                      <CustomTextField
                        name={"evaporator.chwInletPressure"}
                        onBlurFunc={onBlurFunc}
                        type="number"
                        label={"CHW Inlet Pressure"}
                      />
                    </div>
                    <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                      <CustomTextField
                        name={"evaporator.chwOutletPressure"}
                        onBlurFunc={onBlurFunc}
                        type="number"
                        label={"CHW Outlet Pressure"}
                      />
                    </div>
                    <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                      <CustomTextField
                        name={"evaporator.activeChwSetPoint"}
                        onBlurFunc={onBlurFunc}
                        type="number"
                        label={"Active CHW Setpoint"}
                      />
                    </div>
                    <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                      <CustomTextField
                        name={"evaporator.chwInletTemperature"}
                        onBlurFunc={onBlurFunc}
                        type="number"
                        label={"CHW Inlet/Entering Temp"}
                      />
                    </div>
                    <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                      <CustomTextField
                        name={"evaporator.chwOutletTemperature"}
                        onBlurFunc={onBlurFunc}
                        type="number"
                        label={"CHW Outlet/Leaving Temp"}
                      />
                    </div>
                    <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                      <CustomTextField
                        name={"evaporator.refrigerantSaturatedTempCkt01"}
                        onBlurFunc={onBlurFunc}
                        type="number"
                        label={"Refrigerent Saturated Temp CKT 01"}
                      />
                    </div>
                    <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                      <CustomTextField
                        name={"evaporator.refrigerantPressureCkt01"}
                        onBlurFunc={onBlurFunc}
                        type="number"
                        label={"Refrigerant Pressure CKT 01"}
                      />
                    </div>
                    <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                      <CustomTextField
                        name={"evaporator.approachCkt01"}
                        onBlurFunc={onBlurFunc}
                        type="number"
                        label={"Evap. Approch CKT 01"}
                      />
                    </div>
                    {state.wccReading.circuitType === "double" && (
                      <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                        <CustomTextField
                          name={"evaporator.refrigerantSaturatedTempCkt02"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Refrigerent Saturated Temp CKT 02"}
                        />
                      </div>
                    )}
                    {state.wccReading.circuitType === "double" && (
                      <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                        <CustomTextField
                          name={"evaporator.refrigerantPressureCkt02"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Refrigerant Pressure CKT 02"}
                        />
                      </div>
                    )}
                    {state.wccReading.circuitType === "double" && (
                      <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                        <CustomTextField
                          name={"evaporator.approachCkt02"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Evap. Approch CKT 02"}
                        />
                      </div>
                    )}
                    <div className="ms-Grid-col ms-xs12 ms-sm12">
                      <CategoryHeader title="CONDENSER" />
                    </div>
                    <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                      <CustomTextField
                        name={"condenser.inletPressure"}
                        onBlurFunc={onBlurFunc}
                        type="number"
                        label={"Condenser Inlet Pressure"}
                      />
                    </div>
                    <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                      <CustomTextField
                        name={"condenser.outletPressure"}
                        onBlurFunc={onBlurFunc}
                        type="number"
                        label={"Condenser Outlet Pressure"}
                      />
                    </div>
                    <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                      <CustomTextField
                        name={"condenser.inletTemperature"}
                        onBlurFunc={onBlurFunc}
                        type="number"
                        label={"Condenser Inlet/Entering Temp"}
                      />
                    </div>
                    <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                      <CustomTextField
                        name={"condenser.outletTemperature"}
                        onBlurFunc={onBlurFunc}
                        type="number"
                        label={"Condenser Outlet/Leaving Temp"}
                      />
                    </div>
                    <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                      <CustomTextField
                        name={"condenser.refrigerantSaturatedTempCkt01"}
                        onBlurFunc={onBlurFunc}
                        type="number"
                        label={"Refrigerent Saturated Temp CKT 01"}
                      />
                    </div>
                    <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                      <CustomTextField
                        name={"condenser.refrigerantPressureCkt01"}
                        onBlurFunc={onBlurFunc}
                        type="number"
                        label={"Refrigerant Pressure CKT 01"}
                      />
                    </div>
                    <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                      <CustomTextField
                        name={"condenser.approachCkt01"}
                        onBlurFunc={onBlurFunc}
                        type="number"
                        label={"Condenser Approach CKT 01"}
                      />
                    </div>
                    {state.wccReading.circuitType === "double" && (
                      <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                        <CustomTextField
                          name={"condenser.refrigerantSaturatedTempCkt02"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Refrigerent Saturated Temp CKT 02"}
                        />
                      </div>
                    )}
                    {state.wccReading.circuitType === "double" && (
                      <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                        <CustomTextField
                          name={"condenser.refrigerantPressureCkt02"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Refrigerant Pressure CKT 02"}
                        />
                      </div>
                    )}
                    {state.wccReading.circuitType === "double" && (
                      <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                        <CustomTextField
                          name={"condenser.approachCkt02"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Condenser Approach CKT 02"}
                        />
                      </div>
                    )}
                    <div className="ms-Grid-col ms-xs12 ms-sm12">
                      <CategoryHeader title="COMPRESSOR" />
                    </div>
                    <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4 custom-datepicker">
                      {/* <DatePicker
                        firstDayOfWeek={DayOfWeek.Sunday}
                        showMonthPickerAsOverlay={true}
                        showGoToToday={false}
                        value={new Date(values.compressor.startsCkt01)}
                        onSelectDate={(date: Date | null | undefined) =>
                          setFieldValue("compressor.startsCkt01", date)
                        }
                        label="Starts Time CKT 01"
                      /> */}
                      <label className="ms-Label">Starts Time CKT 01</label>
                      <Datetime
                        className="custom-field-group ms-TextField-fieldGroup "
                        inputProps={{
                          className: "ms-TextField-field px-8 border-0 w-100",
                        }}
                        dateFormat="ddd MMM DD YYYY"
                        timeFormat="HH:mm"
                        value={new Date(values.compressor.startsCkt01)}
                        onChange={(date) => {
                          setFieldValue("compressor.startCkt01", date);
                        }}
                      />
                    </div>
                    {state.wccReading.circuitType === "double" && (
                      <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4 custom-datepicker">
                        {/* <DatePicker
                          firstDayOfWeek={DayOfWeek.Sunday}
                          showMonthPickerAsOverlay={true}
                          showGoToToday={false}
                          value={new Date(values.compressor.startsCkt02)}
                          onSelectDate={(date: Date | null | undefined) =>
                            setFieldValue("compressor.startsCkt02", date)
                          }
                          label="Starts Time CKT 02"
                        /> */}
                        <label className="ms-Label">Starts Time CKT 02</label>
                        <Datetime
                          className="custom-field-group ms-TextField-fieldGroup "
                          inputProps={{
                            className: "ms-TextField-field px-8 border-0 w-100",
                          }}
                          dateFormat="ddd MMM DD YYYY"
                          timeFormat="HH:mm"
                          value={new Date(values.compressor.startsCkt02)}
                          onChange={(date) => {
                            setFieldValue("compressor.startCkt02", date);
                          }}
                        />
                      </div>
                    )}
                    <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                      <CustomTextField
                        name={"compressor.runningTimeCkt01"}
                        onBlurFunc={onBlurFunc}
                        type="number"
                        label={"Running Time CKT 01"}
                      />
                    </div>
                    <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                      <CustomTextField
                        name={"compressor.oilTankPressureCkt01"}
                        onBlurFunc={onBlurFunc}
                        type="number"
                        label={"Oil Tank Pressure CKT 01"}
                      />
                    </div>
                    <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                      <CustomTextField
                        name={"compressor.oilDischargePressureCkt01"}
                        onBlurFunc={onBlurFunc}
                        type="number"
                        label={"Oil Discharg Pressure CKT 01"}
                      />
                    </div>
                    <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                      <CustomTextField
                        name={"compressor.oilDiffOilPressureCkt01"}
                        onBlurFunc={onBlurFunc}
                        type="number"
                        label={"Oil Diff. Oil Pressure (KPad) CKT 01"}
                      />
                    </div>
                    <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                      <CustomTextField
                        name={"compressor.oilTankTempCkt01"}
                        onBlurFunc={onBlurFunc}
                        type="number"
                        label={"Oil Tank Temp CKT 01"}
                      />
                    </div>
                    <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                      <CustomTextField
                        name={"compressor.igvPositionCkt01"}
                        onBlurFunc={onBlurFunc}
                        type="number"
                        label={"IGV Position % CKT 01"}
                      />
                    </div>
                    <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                      <CustomTextField
                        name={"compressor.igvStepsCkt01"}
                        onBlurFunc={onBlurFunc}
                        type="number"
                        label={"IGV Steps CKT 01"}
                      />
                    </div>
                    {state.wccReading.circuitType === "double" && (
                      <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                        <CustomTextField
                          name={"compressor.runningTimeCkt02"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Running Time CKT 02"}
                        />
                      </div>
                    )}
                    {state.wccReading.circuitType === "double" && (
                      <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                        <CustomTextField
                          name={"compressor.oilTankPressureCkt02"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Oil Tank Pressure CKT 02"}
                        />
                      </div>
                    )}

                    {state.wccReading.circuitType === "double" && (
                      <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                        <CustomTextField
                          name={"compressor.oilDischargePressureCkt02"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Oil Discharg Pressure CKT 02"}
                        />
                      </div>
                    )}
                    {state.wccReading.circuitType === "double" && (
                      <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                        <CustomTextField
                          name={"compressor.oilDiffOilPressureCkt02"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Oil Diff. Oil Pressure (KPad) CKT 02"}
                        />
                      </div>
                    )}
                    {state.wccReading.circuitType === "double" && (
                      <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                        <CustomTextField
                          name={"compressor.oilTankTempCkt02"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Oil Tank Temp CKT 02"}
                        />
                      </div>
                    )}
                    {state.wccReading.circuitType === "double" && (
                      <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                        <CustomTextField
                          name={"compressor.igvPositionCkt02"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"IGV Position % CKT 02"}
                        />
                      </div>
                    )}
                    {state.wccReading.circuitType === "double" && (
                      <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                        <CustomTextField
                          name={"compressor.igvStepsCkt02"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"IGV Steps CKT 02"}
                        />
                      </div>
                    )}
                    <div className="ms-Grid-col ms-xs12 ms-sm12">
                      <CategoryHeader title="MOTOR" />
                    </div>
                    <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                      <CustomTextField
                        name={"motor.rlaL1Ckt01"}
                        onBlurFunc={onBlurFunc}
                        type="number"
                        label={"% RLA L1 CKT 01"}
                      />
                    </div>
                    <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                      <CustomTextField
                        name={"motor.rlaL2Ckt01"}
                        onBlurFunc={onBlurFunc}
                        type="number"
                        label={"% RLA L2 CKT 01"}
                      />
                    </div>
                    <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                      <CustomTextField
                        name={"motor.rlaL3Ckt01"}
                        onBlurFunc={onBlurFunc}
                        type="number"
                        label={"% RLA L3 CKT 01"}
                      />
                    </div>
                    <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                      <CustomTextField
                        name={"motor.compLineCurrentL1Ckt01"}
                        onBlurFunc={onBlurFunc}
                        type="number"
                        label={"Comp. Line Current L1 CKT 01"}
                      />
                    </div>
                    <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                      <CustomTextField
                        name={"motor.compLineCurrentL2Ckt01"}
                        onBlurFunc={onBlurFunc}
                        type="number"
                        label={"Comp. Line Current L2 CKT 01"}
                      />
                    </div>
                    <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                      <CustomTextField
                        name={"motor.compLineCurrentL3Ckt01"}
                        onBlurFunc={onBlurFunc}
                        type="number"
                        label={"Comp. Line Current L3 CKT 01"}
                      />
                    </div>
                    <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                      <CustomTextField
                        name={"motor.compLineVoltABCkt01"}
                        onBlurFunc={onBlurFunc}
                        type="number"
                        label={"Comp. Line Volts AB CKT 01"}
                      />
                    </div>
                    <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                      <CustomTextField
                        name={"motor.compLineVoltBCCkt01"}
                        onBlurFunc={onBlurFunc}
                        type="number"
                        label={"Comp. Line Volts BC CKT 01"}
                      />
                    </div>
                    <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                      <CustomTextField
                        name={"motor.compLineVoltACCkt01"}
                        onBlurFunc={onBlurFunc}
                        type="number"
                        label={"Comp. Line Volts AC CKT 01"}
                      />
                    </div>
                    <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                      <CustomTextField
                        name={"motor.compressorKilowattsCkt01"}
                        onBlurFunc={onBlurFunc}
                        type="number"
                        label={"Compressor Kilowatts CKT 01"}
                      />
                    </div>
                    <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                      <CustomTextField
                        name={"motor.compressorPowerFactorCkt01"}
                        onBlurFunc={onBlurFunc}
                        type="number"
                        label={"Compressor Power Factor CKT 01"}
                      />
                    </div>
                    <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                      <CustomTextField
                        name={"motor.compWindingTempW1Ckt01"}
                        onBlurFunc={onBlurFunc}
                        type="number"
                        label={"Comp. Winding Temp W1 CKT 01"}
                      />
                    </div>
                    <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                      <CustomTextField
                        name={"motor.compWindingTempW2Ckt01"}
                        onBlurFunc={onBlurFunc}
                        type="number"
                        label={"Comp. Winding Temp W2 CKT 01"}
                      />
                    </div>
                    <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                      <CustomTextField
                        name={"motor.compWindingTempW3Ckt01"}
                        onBlurFunc={onBlurFunc}
                        type="number"
                        label={"Comp. Winding Temp W3 CKT 01"}
                      />
                    </div>
                    {state.wccReading.circuitType === "double" && (
                      <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                        <CustomTextField
                          name={"motor.rlaL1Ckt02"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"% RLA L1 CKT 02"}
                        />
                      </div>
                    )}
                    {state.wccReading.circuitType === "double" && (
                      <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                        <CustomTextField
                          name={"motor.rlaL2Ckt02"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"% RLA L2 CKT 02"}
                        />
                      </div>
                    )}
                    {state.wccReading.circuitType === "double" && (
                      <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                        <CustomTextField
                          name={"motor.rlaL3Ckt02"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"% RLA L3 CKT 02"}
                        />
                      </div>
                    )}
                    {state.wccReading.circuitType === "double" && (
                      <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                        <CustomTextField
                          name={"motor.compLineCurrentL1Ckt02"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Comp. Line Current L1 CKT 02"}
                        />
                      </div>
                    )}
                    {state.wccReading.circuitType === "double" && (
                      <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                        <CustomTextField
                          name={"motor.compLineCurrentL2Ckt02"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Comp. Line Current L2 CKT 02"}
                        />
                      </div>
                    )}
                    {state.wccReading.circuitType === "double" && (
                      <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                        <CustomTextField
                          name={"motor.compLineCurrentL3Ckt02"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Comp. Line Current L3 CKT 02"}
                        />
                      </div>
                    )}
                    {state.wccReading.circuitType === "double" && (
                      <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                        <CustomTextField
                          name={"motor.compLineCurrentL1Ckt02"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Comp. Line Current L1 CKT 02"}
                        />
                      </div>
                    )}
                    {state.wccReading.circuitType === "double" && (
                      <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                        <CustomTextField
                          name={"motor.compLineCurrentL2Ckt02"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Comp. Line Current L2 CKT 02"}
                        />
                      </div>
                    )}
                    {state.wccReading.circuitType === "double" && (
                      <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                        <CustomTextField
                          name={"motor.compLineCurrentL3Ckt02"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Comp. Line Current L3 CKT 02"}
                        />
                      </div>
                    )}
                    {state.wccReading.circuitType === "double" && (
                      <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                        <CustomTextField
                          name={"motor.compLineVoltABCkt02"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Comp. Line Volts AB CKT 02"}
                        />
                      </div>
                    )}
                    {state.wccReading.circuitType === "double" && (
                      <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                        <CustomTextField
                          name={"motor.compLineVoltBCCkt02"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Comp. Line Volts BC CKT 02"}
                        />
                      </div>
                    )}
                    {state.wccReading.circuitType === "double" && (
                      <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                        <CustomTextField
                          name={"motor.compLineVoltACCkt02"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Comp. Line Volts AC CKT 02"}
                        />
                      </div>
                    )}
                    {state.wccReading.circuitType === "double" && (
                      <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                        <CustomTextField
                          name={"motor.compressorKilowattsCkt02"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Compressor Kilowatts CKT 02"}
                        />
                      </div>
                    )}
                    {state.wccReading.circuitType === "double" && (
                      <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                        <CustomTextField
                          name={"motor.compressorPowerFactorCkt02"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Compressor Power Factor CKT 02"}
                        />
                      </div>
                    )}
                    {state.wccReading.circuitType === "double" && (
                      <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                        <CustomTextField
                          name={"motor.compWindingTempW1Ckt02"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Comp. Winding Temp W1 CKT 02"}
                        />
                      </div>
                    )}
                    {state.wccReading.circuitType === "double" && (
                      <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                        <CustomTextField
                          name={"motor.compWindingTempW2Ckt02"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Comp. Winding Temp W2 CKT 02"}
                        />
                      </div>
                    )}
                    {state.wccReading.circuitType === "double" && (
                      <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                        <CustomTextField
                          name={"motor.compWindingTempW3Ckt02"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Comp. Winding Temp W3 CKT 02"}
                        />
                      </div>
                    )}
                    <div className="ms-Grid-col ms-xs12 ms-sm12">
                      <CategoryHeader title="PURGE" />
                    </div>
                    <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                      <CustomTextField
                        name={"purge.runningTimeCkt01"}
                        onBlurFunc={onBlurFunc}
                        type="number"
                        label={"Time Until Next Purge CKT 01"}
                      />
                    </div>
                    <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                      <CustomTextField
                        name={"purge.dailyPumpOutCkt01"}
                        onBlurFunc={onBlurFunc}
                        type="number"
                        label={"Daily Pump Out-24 Hrs CKT 01"}
                      />
                    </div>
                    <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                      <CustomTextField
                        name={"purge.avgPumpOutCkt01"}
                        onBlurFunc={onBlurFunc}
                        type="number"
                        label={"Avg Pump Out-7 Days CKT 01"}
                      />
                    </div>
                    <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                      <CustomTextField
                        name={"purge.dailyPumpOutLimitCkt01"}
                        onBlurFunc={onBlurFunc}
                        type="number"
                        label={"Daily Pump Out Limit CKT 01"}
                      />
                    </div>
                    <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                      <CustomTextField
                        name={"purge.chillerOn7DaysCkt01"}
                        onBlurFunc={onBlurFunc}
                        type="number"
                        label={"Chiller on 7 Days CKT 01"}
                      />
                    </div>
                    <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                      <CustomTextField
                        name={"purge.pumpOutChillerOn7DaysCkt01"}
                        onBlurFunc={onBlurFunc}
                        type="number"
                        label={"Pumpout Chiller On 7 Days CKT 01"}
                      />
                    </div>
                    <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                      <CustomTextField
                        name={"purge.pumpOutChillerOff7DaysCkt01"}
                        onBlurFunc={onBlurFunc}
                        type="number"
                        label={"Pumpout Chiller Off 7 Days CKT 01"}
                      />
                    </div>
                    <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                      <CustomTextField
                        name={"purge.pumpOutLifeCkt01"}
                        onBlurFunc={onBlurFunc}
                        type="number"
                        label={"Pump Out Life CKT 01"}
                      />
                    </div>
                    <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                      <CustomTextField
                        name={"purge.purgeRefCompSuctionTempCkt01"}
                        onBlurFunc={onBlurFunc}
                        type="number"
                        label={"Purge ref Comp. Suction Temp CKT 01"}
                      />
                    </div>
                    <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                      <CustomTextField
                        name={"purge.purgeLiquidTempCkt01"}
                        onBlurFunc={onBlurFunc}
                        type="number"
                        label={"Purge Liquid Temp CKT 01"}
                      />
                    </div>
                    <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                      <CustomTextField
                        name={"purge.carbonTankTempCkt01"}
                        onBlurFunc={onBlurFunc}
                        type="number"
                        label={"Carbon Tank Temp CKT 01"}
                      />
                    </div>
                    <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                      <CustomTextField
                        name={"purge.oilTankLevelCkt01"}
                        onBlurFunc={onBlurFunc}
                        type="number"
                        label={"Oil Tank Level CKT 01"}
                      />
                    </div>
                    {state.wccReading.circuitType === "double" && (
                      <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                        <CustomTextField
                          name={"purge.timeUntilNextPurgeCkt02"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Time Until Next Purge CKT 02"}
                        />
                      </div>
                    )}
                    {state.wccReading.circuitType === "double" && (
                      <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                        <CustomTextField
                          name={"purge.dailyPumpOutCkt02"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Daily Pump Out-24 Hrs CKT 02"}
                        />
                      </div>
                    )}
                    {state.wccReading.circuitType === "double" && (
                      <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                        <CustomTextField
                          name={"purge.avgPumpOutCkt02"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Avg Pump Out-7 Days CKT 02"}
                        />
                      </div>
                    )}
                    {state.wccReading.circuitType === "double" && (
                      <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                        <CustomTextField
                          name={"purge.pumpOutChillerOn7DaysCkt02"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Pumpout Chiller On 7 Days CKT 02"}
                        />
                      </div>
                    )}
                    {state.wccReading.circuitType === "double" && (
                      <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                        <CustomTextField
                          name={"purge.dailyPumpOutLimitCkt02"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Daily Pump Out Limit CKT 02"}
                        />
                      </div>
                    )}
                    {state.wccReading.circuitType === "double" && (
                      <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                        <CustomTextField
                          name={"purge.chillerOn7DaysCkt02"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Chiller on 7 Days CKT 02"}
                        />
                      </div>
                    )}
                    {state.wccReading.circuitType === "double" && (
                      <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                        <CustomTextField
                          name={"purge.pumpOutChillerOff7DaysCkt02"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Pumpout Chiller Off 7 Days CKT 02"}
                        />
                      </div>
                    )}
                    {state.wccReading.circuitType === "double" && (
                      <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                        <CustomTextField
                          name={"purge.pumpOutLifeCkt02"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Pump Out Life CKT 02"}
                        />
                      </div>
                    )}
                    {state.wccReading.circuitType === "double" && (
                      <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                        <CustomTextField
                          name={"purge.purgeRefCompSuctionTempCkt02"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Purge ref Comp. Suction Temp CKT 02"}
                        />
                      </div>
                    )}
                    {state.wccReading.circuitType === "double" && (
                      <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                        <CustomTextField
                          name={"purge.purgeLiquidTempCkt02"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Purge Liquid Temp CKT 02"}
                        />
                      </div>
                    )}
                    {state.wccReading.circuitType === "double" && (
                      <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                        <CustomTextField
                          name={"purge.carbonTankTempCkt02"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Carbon Tank Temp CKT 02"}
                        />
                      </div>
                    )}
                    {state.wccReading.circuitType === "double" && (
                      <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4">
                        <CustomTextField
                          name={"purge.oilTankLevelCkt02"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Oil Tank Level CKT 02"}
                        />
                      </div>
                    )}
                    <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4 custom-toggle">
                      <Toggle
                        checked={values.purge.isPurgeModeAdaptiveCkt01}
                        onText="Adaptive"
                        offText="Non Adaptive"
                        onChange={(e, v) =>
                          setFieldValue("purge.isPurgeModeAdaptiveCkt01", v)
                        }
                        label="Purge Mode CKT 01"
                      />
                    </div>
                    {state.wccReading.circuitType === "double" && (
                      <div className="ms-Grid-col ms-xs12 ms-sm6 ms-md4 custom-toggle">
                        <Toggle
                          checked={values.purge.isPurgeModeAdaptiveCkt02}
                          onText="Adaptive"
                          offText="Non Adaptive"
                          onChange={(e, v) =>
                            setFieldValue("purge.isPurgeModeAdaptiveCkt02", v)
                          }
                          label="Purge Mode CKT 02"
                        />
                      </div>
                    )}

                    <div className="ms-Grid-col ms-xs12 ms-sm12">
                      <CategoryHeader title="General" />
                    </div>
                    <div className="ms-Grid-col ms-xs12 ms-sm12">
                      <CustomTextField
                        name={"remarks"}
                        label={"Remarks (If Any)"}
                        multiline
                        autoAdjustHeight
                      />
                    </div>
                    <div className="ms-Grid-col ms-xs12 ms-sm12">
                      <CustomTextField
                        name={"recordedBy"}
                        label={"Shift Tech Sign"}
                        disabled={true}
                      />
                    </div>
                  </div>
                </div>
                <div>
                  <Stack
                    horizontal
                    wrap
                    tokens={wrapStackTokens}
                    horizontalAlign="end"
                    className="pt-8"
                  >
                    <DefaultButton
                      text="Cancel"
                      onClick={() => closeUpdateDialoge()}
                      className="borderless-btn"
                    />
                    <PrimaryButton type="submit" text="Update" />
                  </Stack>
                </div>

                {/* <Stack wrap tokens={wrapStackTokens}>
                  <Stack.Item>
                    <CategoryHeader title="EVAPORATOR:" />
                    <Stack horizontal wrap tokens={wrapStackTokens}>
                      <Stack.Item grow={1}>
                        <CustomTextField
                          name={"evaporator.chwInletPressure"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"CHW Inlet Pressure"}
                        />
                      </Stack.Item>
                      <Stack.Item grow={1}>
                        <CustomTextField
                          name={"evaporator.chwOutletPressure"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"CHW Outlet Pressure"}
                        />
                      </Stack.Item>
                      <Stack.Item grow={1}>
                        <CustomTextField
                          name={"evaporator.activeChwSetPoint"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Active CHW Setpoint"}
                        />
                      </Stack.Item>
                    </Stack>
                  </Stack.Item>

                  <Stack.Item>
                    <Stack horizontal wrap tokens={wrapStackTokens}>
                      <Stack.Item grow={1}>
                        <CustomTextField
                          name={"evaporator.chwInletTemperature"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"CHW Inlet/Entering Temp"}
                        />
                      </Stack.Item>
                      <Stack.Item grow={1}>
                        <CustomTextField
                          name={"evaporator.chwOutletTemperature"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"CHW Outlet/Leaving Temp"}
                        />
                      </Stack.Item>
                      <Stack.Item grow={1}>
                        <CustomTextField
                          name={"evaporator.refrigerantSaturatedTempCkt01"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Refrigerent Saturated Temp CKT 01"}
                        />
                      </Stack.Item>
                    </Stack>
                  </Stack.Item>

                  <Stack.Item>
                    <Stack horizontal wrap tokens={wrapStackTokens}>
                      <Stack.Item grow={1}>
                        <CustomTextField
                          name={"evaporator.refrigerantPressureCkt01"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Refrigerant Pressure CKT 01"}
                        />
                      </Stack.Item>
                      <Stack.Item grow={1}>
                        <CustomTextField
                          name={"evaporator.approachCkt01"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Evap. Approch CKT 01"}
                        />
                      </Stack.Item>
                    </Stack>
                  </Stack.Item>

                  {state.wccReading.circuitType === "double" && (
                    <Stack.Item>
                      <Stack horizontal wrap tokens={wrapStackTokens}>
                        <Stack.Item grow={1}>
                          <CustomTextField
                            name={"evaporator.refrigerantSaturatedTempCkt02"}
                            onBlurFunc={onBlurFunc}
                            type="number"
                            label={"Refrigerent Saturated Temp CKT 02"}
                          />
                        </Stack.Item>
                        <Stack.Item grow={1}>
                          <CustomTextField
                            name={"evaporator.refrigerantPressureCkt02"}
                            onBlurFunc={onBlurFunc}
                            type="number"
                            label={"Refrigerant Pressure CKT 02"}
                          />
                        </Stack.Item>
                        <Stack.Item grow={1}>
                          <CustomTextField
                            name={"evaporator.approachCkt02"}
                            onBlurFunc={onBlurFunc}
                            type="number"
                            label={"Evap. Approch CKT 02"}
                          />
                        </Stack.Item>
                      </Stack>
                    </Stack.Item>
                  )}

                  <Stack.Item>
                    <CategoryHeader title="CONDENSER:" />
                    <Stack horizontal wrap tokens={wrapStackTokens}>
                      <Stack.Item grow={1}>
                        <CustomTextField
                          name={"condenser.inletPressure"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Condenser Inlet Pressure"}
                        />
                      </Stack.Item>
                      <Stack.Item grow={1}>
                        <CustomTextField
                          name={"condenser.outletPressure"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Condenser Outlet Pressure"}
                        />
                      </Stack.Item>
                      <Stack.Item grow={1}>
                        <CustomTextField
                          name={"condenser.inletTemperature"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Condenser Inlet/Entering Temp"}
                        />
                      </Stack.Item>
                    </Stack>
                  </Stack.Item>

                  <Stack.Item>
                    <Stack horizontal wrap tokens={wrapStackTokens}>
                      <Stack.Item grow={1}>
                        <CustomTextField
                          name={"condenser.outletTemperature"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Condenser Outlet/Leaving Temp"}
                        />
                      </Stack.Item>
                      <Stack.Item grow={1}>
                        <CustomTextField
                          name={"condenser.refrigerantSaturatedTempCkt01"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Refrigerent Saturated Temp CKT 01"}
                        />
                      </Stack.Item>
                      <Stack.Item grow={1}>
                        <CustomTextField
                          name={"condenser.refrigerantPressureCkt01"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Refrigerant Pressure CKT 01"}
                        />
                      </Stack.Item>
                    </Stack>
                  </Stack.Item>

                  <Stack.Item>
                    <Stack.Item grow={1}>
                      <CustomTextField
                        name={"condenser.approachCkt01"}
                        onBlurFunc={onBlurFunc}
                        type="number"
                        label={"Condenser Approach CKT 01"}
                      />
                    </Stack.Item>
                  </Stack.Item>

                  {isDouble && (
                    <Stack.Item>
                      <Stack horizontal wrap tokens={wrapStackTokens}>
                        <Stack.Item grow={1}>
                          <CustomTextField
                            name={"condenser.refrigerantSaturatedTempCkt02"}
                            onBlurFunc={onBlurFunc}
                            type="number"
                            label={"Refrigerent Saturated Temp CKT 02"}
                          />
                        </Stack.Item>
                        <Stack.Item grow={1}>
                          <CustomTextField
                            name={"condenser.refrigerantPressureCkt02"}
                            onBlurFunc={onBlurFunc}
                            type="number"
                            label={"Refrigerant Pressure CKT 02"}
                          />
                        </Stack.Item>
                        <Stack.Item grow={1}>
                          <CustomTextField
                            name={"condenser.approachCkt02"}
                            onBlurFunc={onBlurFunc}
                            type="number"
                            label={"Condenser Approach CKT 02"}
                          />
                        </Stack.Item>
                      </Stack>
                    </Stack.Item>
                  )}

                  <Stack.Item>
                    <CategoryHeader title="COMPRESSOR:" />
                    <Stack horizontal wrap tokens={wrapStackTokens}>
                      <Stack.Item grow={1}>
                        <CustomTextField
                          name={"compressor.runningTimeCkt01"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Running Time CKT 01"}
                        />
                      </Stack.Item>
                      <Stack.Item grow={1}>
                        <CustomTextField
                          name={"compressor.oilTankPressureCkt01"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Oil Tank Pressure CKT 01"}
                        />
                      </Stack.Item>
                      <Stack.Item grow={1}>
                        <CustomTextField
                          name={"compressor.oilDischargePressureCkt01"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Oil Discharg Pressure CKT 01"}
                        />
                      </Stack.Item>
                    </Stack>
                  </Stack.Item>

                  <Stack.Item>
                    <Stack horizontal wrap tokens={wrapStackTokens}>
                      <Stack.Item grow={1}>
                        <DatePicker
                          firstDayOfWeek={DayOfWeek.Sunday}
                          showMonthPickerAsOverlay={true}
                          showGoToToday={false}
                          value={new Date(values.compressor.startsCkt01)}
                          onSelectDate={(date: Date | null | undefined) =>
                            setFieldValue("compressor.startsCkt01", date)
                          }
                        />
                      </Stack.Item>
                      {isDouble && (
                        <Stack.Item grow={1}>
                          <DatePicker
                            firstDayOfWeek={DayOfWeek.Sunday}
                            showMonthPickerAsOverlay={true}
                            showGoToToday={false}
                            value={new Date(values.compressor.startsCkt02)}
                            onSelectDate={(date: Date | null | undefined) =>
                              setFieldValue("compressor.startsCkt02", date)
                            }
                          />
                        </Stack.Item>
                      )}
                    </Stack>
                  </Stack.Item>

                  <Stack.Item>
                    <Stack horizontal wrap tokens={wrapStackTokens}>
                      <Stack.Item grow={1}>
                        <CustomTextField
                          name={"compressor.oilDiffOilPressureCkt01"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Oil Diff. Oil Pressure (KPad) CKT 01"}
                        />
                      </Stack.Item>
                      <Stack.Item grow={1}>
                        <CustomTextField
                          name={"compressor.oilTankTempCkt01"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Oil Tank Temp CKT 01"}
                        />
                      </Stack.Item>
                      <Stack.Item grow={1}>
                        <CustomTextField
                          name={"compressor.igvPositionCkt01"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"IGV Position % CKT 01"}
                        />
                      </Stack.Item>
                    </Stack>
                  </Stack.Item>

                  <Stack.Item>
                    <CustomTextField
                      name={"compressor.igvStepsCkt01"}
                      onBlurFunc={onBlurFunc}
                      type="number"
                      label={"IGV Steps CKT 01"}
                    />
                  </Stack.Item>

                  {isDouble && (
                    <Stack.Item>
                      <Stack horizontal wrap tokens={wrapStackTokens}>
                        <Stack.Item grow={1}>
                          <CustomTextField
                            name={"compressor.runningTimeCkt02"}
                            onBlurFunc={onBlurFunc}
                            type="number"
                            label={"Running Time CKT 02"}
                          />
                        </Stack.Item>
                        <Stack.Item grow={1}>
                          <CustomTextField
                            name={"compressor.oilTankPressureCkt02"}
                            onBlurFunc={onBlurFunc}
                            type="number"
                            label={"Oil Tank Pressure CKT 02"}
                          />
                        </Stack.Item>
                        <Stack.Item grow={1}>
                          <CustomTextField
                            name={"compressor.oilDischargePressureCkt02"}
                            onBlurFunc={onBlurFunc}
                            type="number"
                            label={"Oil Discharg Pressure CKT 02"}
                          />
                        </Stack.Item>
                      </Stack>
                    </Stack.Item>
                  )}

                  {isDouble && (
                    <Stack.Item>
                      <Stack horizontal wrap tokens={wrapStackTokens}>
                        <Stack.Item grow={1}>
                          <CustomTextField
                            name={"compressor.oilDiffOilPressureCkt02"}
                            onBlurFunc={onBlurFunc}
                            type="number"
                            label={"Oil Diff. Oil Pressure (KPad) CKT 02"}
                          />
                        </Stack.Item>
                        <Stack.Item grow={1}>
                          <CustomTextField
                            name={"compressor.oilTankTempCkt02"}
                            onBlurFunc={onBlurFunc}
                            type="number"
                            label={"Oil Tank Temp CKT 02"}
                          />
                        </Stack.Item>
                        <Stack.Item grow={1}>
                          <CustomTextField
                            name={"compressor.igvPositionCkt02"}
                            onBlurFunc={onBlurFunc}
                            type="number"
                            label={"IGV Position % CKT 02"}
                          />
                        </Stack.Item>
                      </Stack>
                    </Stack.Item>
                  )}

                  {isDouble && (
                    <Stack.Item>
                      <Stack.Item grow={1}>
                        <CustomTextField
                          name={"compressor.igvStepsCkt02"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"IGV Steps CKT 02"}
                        />
                      </Stack.Item>
                    </Stack.Item>
                  )}

                  <Stack.Item>
                    <CategoryHeader title="MOTOR:" />
                    <Stack horizontal wrap tokens={wrapStackTokens}>
                      <Stack.Item grow={1}>
                        <CustomTextField
                          name={"motor.rlaL1Ckt01"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"% RLA L1 CKT 01"}
                        />
                      </Stack.Item>
                      <Stack.Item grow={1}>
                        <CustomTextField
                          name={"motor.rlaL2Ckt01"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"% RLA L2 CKT 01"}
                        />
                      </Stack.Item>
                      <Stack.Item grow={1}>
                        <CustomTextField
                          name={"motor.rlaL3Ckt01"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"% RLA L3 CKT 01"}
                        />
                      </Stack.Item>
                    </Stack>
                  </Stack.Item>

                  <Stack.Item>
                    <Stack horizontal wrap tokens={wrapStackTokens}>
                      <Stack.Item grow={1}>
                        <CustomTextField
                          name={"motor.compLineCurrentL1Ckt01"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Comp. Line Current L1 CKT 01"}
                        />
                      </Stack.Item>
                      <Stack.Item grow={1}>
                        <CustomTextField
                          name={"motor.compLineCurrentL2Ckt01"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Comp. Line Current L2 CKT 01"}
                        />
                      </Stack.Item>
                      <Stack.Item grow={1}>
                        <CustomTextField
                          name={"motor.compLineCurrentL3Ckt01"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Comp. Line Current L3 CKT 01"}
                        />
                      </Stack.Item>
                    </Stack>
                  </Stack.Item>

                  <Stack.Item>
                    <Stack horizontal wrap tokens={wrapStackTokens}>
                      <Stack.Item grow={1}>
                        <CustomTextField
                          name={"motor.compLineVoltABCkt01"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Comp. Line Volts AB CKT 01"}
                        />
                      </Stack.Item>

                      <Stack.Item grow={1}>
                        <CustomTextField
                          name={"motor.compLineVoltBCCkt01"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Comp. Line Volts BC CKT 01"}
                        />
                      </Stack.Item>
                      <Stack.Item grow={1}>
                        <CustomTextField
                          name={"motor.compLineVoltACCkt01"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Comp. Line Volts AC CKT 01"}
                        />
                      </Stack.Item>
                    </Stack>
                  </Stack.Item>

                  <Stack.Item>
                    <Stack horizontal wrap tokens={wrapStackTokens}>
                      <Stack.Item grow={1}>
                        <CustomTextField
                          name={"motor.compressorKilowattsCkt01"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Compressor Kilowatts CKT 01"}
                        />
                      </Stack.Item>
                      <Stack.Item grow={1}>
                        <CustomTextField
                          name={"motor.compressorPowerFactorCkt01"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Compressor Power Factor CKT 01"}
                        />
                      </Stack.Item>
                      <Stack.Item grow={1}>
                        <CustomTextField
                          name={"motor.compWindingTempW1Ckt01"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Comp. Winding Temp W1 CKT 01"}
                        />
                      </Stack.Item>
                    </Stack>
                  </Stack.Item>

                  <Stack.Item>
                    <Stack horizontal wrap tokens={wrapStackTokens}>
                      <Stack.Item grow={1}>
                        <CustomTextField
                          name={"motor.compWindingTempW2Ckt01"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Comp. Winding Temp W2 CKT 01"}
                        />
                      </Stack.Item>
                      <Stack.Item grow={1}>
                        <CustomTextField
                          name={"motor.compWindingTempW3Ckt01"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Comp. Winding Temp W3 CKT 01"}
                        />
                      </Stack.Item>
                    </Stack>
                  </Stack.Item>

                  {isDouble && (
                    <Stack.Item>
                      <Stack horizontal wrap tokens={wrapStackTokens}>
                        <Stack.Item grow={1}>
                          <CustomTextField
                            name={"motor.rlaL1Ckt02"}
                            onBlurFunc={onBlurFunc}
                            type="number"
                            label={"% RLA L1 CKT 02"}
                          />
                        </Stack.Item>
                        <Stack.Item grow={1}>
                          <CustomTextField
                            name={"motor.rlaL2Ckt02"}
                            onBlurFunc={onBlurFunc}
                            type="number"
                            label={"% RLA L2 CKT 02"}
                          />
                        </Stack.Item>
                        <Stack.Item grow={1}>
                          <CustomTextField
                            name={"motor.rlaL3Ckt02"}
                            onBlurFunc={onBlurFunc}
                            type="number"
                            label={"% RLA L3 CKT 02"}
                          />
                        </Stack.Item>
                      </Stack>
                    </Stack.Item>
                  )}

                  {isDouble && (
                    <Stack.Item>
                      <Stack horizontal wrap tokens={wrapStackTokens}>
                        <Stack.Item grow={1}>
                          <CustomTextField
                            name={"motor.compLineCurrentL1Ckt02"}
                            onBlurFunc={onBlurFunc}
                            type="number"
                            label={"Comp. Line Current L1 CKT 02"}
                          />
                        </Stack.Item>
                        <Stack.Item grow={1}>
                          <CustomTextField
                            name={"motor.compLineCurrentL2Ckt02"}
                            onBlurFunc={onBlurFunc}
                            type="number"
                            label={"Comp. Line Current L2 CKT 02"}
                          />
                        </Stack.Item>
                        <Stack.Item grow={1}>
                          <CustomTextField
                            name={"motor.compLineCurrentL3Ckt02"}
                            onBlurFunc={onBlurFunc}
                            type="number"
                            label={"Comp. Line Current L3 CKT 02"}
                          />
                        </Stack.Item>
                      </Stack>
                    </Stack.Item>
                  )}

                  {isDouble && (
                    <Stack.Item>
                      <Stack horizontal wrap tokens={wrapStackTokens}>
                        <Stack.Item grow={1}>
                          <CustomTextField
                            name={"motor.compLineVoltABCkt02"}
                            onBlurFunc={onBlurFunc}
                            type="number"
                            label={"Comp. Line Volts AB CKT 02"}
                          />
                        </Stack.Item>
                        <Stack.Item grow={1}>
                          <CustomTextField
                            name={"motor.compLineVoltBCCkt02"}
                            onBlurFunc={onBlurFunc}
                            type="number"
                            label={"Comp. Line Volts BC CKT 02"}
                          />
                        </Stack.Item>
                        <Stack.Item grow={1}>
                          <CustomTextField
                            name={"motor.compLineVoltACCkt02"}
                            onBlurFunc={onBlurFunc}
                            type="number"
                            label={"Comp. Line Volts AC CKT 02"}
                          />
                        </Stack.Item>
                      </Stack>
                    </Stack.Item>
                  )}

                  {isDouble && (
                    <Stack.Item>
                      <Stack horizontal wrap tokens={wrapStackTokens}>
                        <Stack.Item grow={1}>
                          <CustomTextField
                            name={"motor.compressorKilowattsCkt02"}
                            onBlurFunc={onBlurFunc}
                            type="number"
                            label={"Compressor Kilowatts CKT 02"}
                          />
                        </Stack.Item>
                        <Stack.Item grow={1}>
                          <CustomTextField
                            name={"motor.compressorPowerFactorCkt02"}
                            onBlurFunc={onBlurFunc}
                            type="number"
                            label={"Compressor Power Factor CKT 02"}
                          />
                        </Stack.Item>
                        <Stack.Item grow={1}>
                          <CustomTextField
                            name={"motor.compWindingTempW1Ckt02"}
                            onBlurFunc={onBlurFunc}
                            type="number"
                            label={"Comp. Winding Temp W1 CKT 02"}
                          />
                        </Stack.Item>
                      </Stack>
                    </Stack.Item>
                  )}

                  {isDouble && (
                    <Stack.Item>
                      <Stack horizontal wrap tokens={wrapStackTokens}>
                        <Stack.Item grow={1}>
                          <CustomTextField
                            name={"motor.compWindingTempW2Ckt02"}
                            onBlurFunc={onBlurFunc}
                            type="number"
                            label={"Comp. Winding Temp W2 CKT 02"}
                          />
                        </Stack.Item>
                        <Stack.Item grow={1}>
                          <CustomTextField
                            name={"motor.compWindingTempW3Ckt02"}
                            onBlurFunc={onBlurFunc}
                            type="number"
                            label={"Comp. Winding Temp W3 CKT 02"}
                          />
                        </Stack.Item>
                      </Stack>
                    </Stack.Item>
                  )}

                  <Stack.Item>
                    <CategoryHeader title="PURGE:" />
                    <Stack horizontal wrap tokens={wrapStackTokens}>
                      <Stack.Item grow={1}>
                        <CustomTextField
                          name={"purge.runningTimeCkt01"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Time Until Next Purge CKT 01"}
                        />
                      </Stack.Item>
                      <Stack.Item grow={1}>
                        <CustomTextField
                          name={"purge.dailyPumpOutCkt01"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Daily Pump Out-24 Hrs CKT 01"}
                        />
                      </Stack.Item>
                      <Stack.Item grow={1}>
                        <CustomTextField
                          name={"purge.avgPumpOutCkt01"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Avg Pump Out-7 Days CKT 01"}
                        />
                      </Stack.Item>
                    </Stack>
                  </Stack.Item>

                  <Stack.Item>
                    <Stack horizontal wrap tokens={wrapStackTokens}>
                      <Stack.Item grow={1}>
                        <CustomTextField
                          name={"purge.dailyPumpOutLimitCkt01"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Daily Pump Out Limit CKT 01"}
                        />
                      </Stack.Item>
                      <Stack.Item grow={1}>
                        <CustomTextField
                          name={"purge.chillerOn7DaysCkt01"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Chiller on 7 Days CKT 01"}
                        />
                      </Stack.Item>
                      <Stack.Item grow={1}>
                        <CustomTextField
                          name={"purge.pumpOutChillerOn7DaysCkt01"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Pumpout Chiller On 7 Days CKT 01"}
                        />
                      </Stack.Item>
                    </Stack>
                  </Stack.Item>

                  <Stack.Item>
                    <Stack horizontal wrap tokens={wrapStackTokens}>
                      <Stack.Item grow={1}>
                        <CustomTextField
                          name={"purge.pumpOutChillerOff7DaysCkt01"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Pumpout Chiller Off 7 Days CKT 01"}
                        />
                      </Stack.Item>
                      <Stack.Item grow={1}>
                        <CustomTextField
                          name={"purge.pumpOutLifeCkt01"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Pump Out Life CKT 01"}
                        />
                      </Stack.Item>
                      <Stack.Item grow={1}>
                        <CustomTextField
                          name={"purge.purgeRefCompSuctionTempCkt01"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Purge ref Comp. Suction Temp CKT 01"}
                        />
                      </Stack.Item>
                    </Stack>
                  </Stack.Item>

                  <Stack.Item>
                    <Stack horizontal wrap tokens={wrapStackTokens}>
                      <Stack.Item grow={1}>
                        <CustomTextField
                          name={"purge.purgeLiquidTempCkt01"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Purge Liquid Temp CKT 01"}
                        />
                      </Stack.Item>
                      <Stack.Item grow={1}>
                        <CustomTextField
                          name={"purge.carbonTankTempCkt01"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Carbon Tank Temp CKT 01"}
                        />
                      </Stack.Item>
                      <Stack.Item grow={1}>
                        <CustomTextField
                          name={"purge.oilTankLevelCkt01"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Oil Tank Level CKT 01"}
                        />
                      </Stack.Item>
                    </Stack>
                  </Stack.Item>

                  {isDouble && (
                    <Stack.Item>
                      <Stack horizontal wrap tokens={wrapStackTokens}>
                        <Stack.Item grow={1}>
                          <CustomTextField
                            name={"purge.timeUntilNextPurgeCkt02"}
                            onBlurFunc={onBlurFunc}
                            type="number"
                            label={"Time Until Next Purge CKT 02"}
                          />
                        </Stack.Item>
                        <Stack.Item grow={1}>
                          <CustomTextField
                            name={"purge.dailyPumpOutCkt02"}
                            onBlurFunc={onBlurFunc}
                            type="number"
                            label={"Daily Pump Out-24 Hrs CKT 02"}
                          />
                        </Stack.Item>
                        <Stack.Item grow={1}>
                          <CustomTextField
                            name={"purge.avgPumpOutCkt02"}
                            onBlurFunc={onBlurFunc}
                            type="number"
                            label={"Avg Pump Out-7 Days CKT 02"}
                          />
                        </Stack.Item>
                      </Stack>
                    </Stack.Item>
                  )}

                  {isDouble && (
                    <Stack.Item>
                      <Stack horizontal wrap tokens={wrapStackTokens}>
                        <Stack.Item grow={1}>
                          <CustomTextField
                            name={"purge.pumpOutChillerOn7DaysCkt02"}
                            onBlurFunc={onBlurFunc}
                            type="number"
                            label={"Pumpout Chiller On 7 Days CKT 02"}
                          />
                        </Stack.Item>
                        <Stack.Item grow={1}>
                          <CustomTextField
                            name={"purge.dailyPumpOutLimitCkt02"}
                            onBlurFunc={onBlurFunc}
                            type="number"
                            label={"Daily Pump Out Limit CKT 02"}
                          />
                        </Stack.Item>
                        <Stack.Item grow={1}>
                          <CustomTextField
                            name={"purge.chillerOn7DaysCkt02"}
                            onBlurFunc={onBlurFunc}
                            type="number"
                            label={"Chiller on 7 Days CKT 02"}
                          />
                        </Stack.Item>
                      </Stack>
                    </Stack.Item>
                  )}

                  {isDouble && (
                    <Stack.Item>
                      <Stack horizontal wrap tokens={wrapStackTokens}>
                        <Stack.Item grow={1}>
                          <CustomTextField
                            name={"purge.pumpOutChillerOff7DaysCkt02"}
                            onBlurFunc={onBlurFunc}
                            type="number"
                            label={"Pumpout Chiller Off 7 Days CKT 02"}
                          />
                        </Stack.Item>

                        <Stack.Item grow={1}>
                          <CustomTextField
                            name={"purge.pumpOutLifeCkt02"}
                            onBlurFunc={onBlurFunc}
                            type="number"
                            label={"Pump Out Life CKT 02"}
                          />
                        </Stack.Item>
                        <Stack.Item grow={1}>
                          <CustomTextField
                            name={"purge.purgeRefCompSuctionTempCkt02"}
                            onBlurFunc={onBlurFunc}
                            type="number"
                            label={"Purge ref Comp. Suction Temp CKT 02"}
                          />
                        </Stack.Item>
                      </Stack>
                    </Stack.Item>
                  )}

                  {isDouble && (
                    <Stack.Item>
                      <Stack horizontal wrap tokens={wrapStackTokens}>
                        <Stack.Item grow={1}>
                          <CustomTextField
                            name={"purge.purgeLiquidTempCkt02"}
                            onBlurFunc={onBlurFunc}
                            type="number"
                            label={"Purge Liquid Temp CKT 02"}
                          />
                        </Stack.Item>
                        <Stack.Item grow={1}>
                          <CustomTextField
                            name={"purge.carbonTankTempCkt02"}
                            onBlurFunc={onBlurFunc}
                            type="number"
                            label={"Carbon Tank Temp CKT 02"}
                          />
                        </Stack.Item>
                        <Stack.Item grow={1}>
                          <CustomTextField
                            name={"purge.oilTankLevelCkt02"}
                            onBlurFunc={onBlurFunc}
                            type="number"
                            label={"Oil Tank Level CKT 02"}
                          />
                        </Stack.Item>
                      </Stack>
                    </Stack.Item>
                  )}

                  <Stack.Item>
                    <Stack horizontal wrap tokens={wrapStackTokens}>
                      <Stack.Item grow={1}>
                        <Toggle
                          checked={values.purge.isPurgeModeAdaptiveCkt01}
                          onText="Adaptive"
                          offText="Non Adaptive"
                          onChange={(e, v) =>
                            setFieldValue("purge.isPurgeModeAdaptiveCkt01", v)
                          }
                          label="Purge Mode CKT 01"
                        />
                      </Stack.Item>
                      {isDouble && (
                        <Stack.Item grow={1}>
                          <Toggle
                            checked={values.purge.isPurgeModeAdaptiveCkt02}
                            onText="Adaptive"
                            offText="Non Adaptive"
                            onChange={(e, v) =>
                              setFieldValue("purge.isPurgeModeAdaptiveCkt02", v)
                            }
                            label="Purge Mode CKT 02"
                          />
                        </Stack.Item>
                      )}
                    </Stack>
                  </Stack.Item>

                  <Stack.Item>
                    <CategoryHeader title="General:" />
                    <Stack.Item>
                      <CustomTextField
                        name={"remarks"}
                        label={"Remarks (If Any)"}
                        multiline
                      />
                    </Stack.Item>
                    <Stack.Item>
                      <CustomTextField
                        name={"recordedBy"}
                        label={"Shift Tech Sign"}
                        disabled={true}
                      />
                    </Stack.Item>
                  </Stack.Item>

                  <Stack.Item>
                    <Stack
                      horizontal
                      wrap
                      tokens={wrapStackTokens}
                      horizontalAlign="end"
                    >
                      <DefaultButton
                        text="Cancel"
                        onClick={() => closeUpdateDialoge()}
                      />
                      <PrimaryButton type="submit" text="Update" />
                    </Stack>
                  </Stack.Item>
                </Stack> */}
              </form>
            )}
          </Formik>
        </Stack>
      </CustomDrawer>
    </React.Fragment>
  );
};

export default ManageWccDialog;
